const getRandomNumber = () => Math.floor(Math.random() * 100000)
const getNegativeRandomNumber = () => Math.floor(Math.random() * -100000)

export default {
  getRandomNumber,
  getNegativeRandomNumber,
}
